import { Dimensions, Platform, StyleSheet } from 'react-native';

const width = Dimensions.get('window').width;

export default StyleSheet.create({
    ConstituentCard: {
        addressVerifiedIndicator: {
            borderRadius: 7,
            borderWidth: 1,
            color: '#fff',
            fontFamily: 'GothamBook',
            fontSize: Platform.OS === 'web' ? '11pt' : 11,
            marginLeft: Platform.OS === 'web' ? '10pt' : 10,
            marginTop: Platform.OS === 'web' ? '5pt' : 5,
            padding: 3,
            textAlign: 'center',
            width: '10%'
        },
        container: {
            alignItems: 'center',
            borderWidth: 0,
            borderRadius: Platform.OS === 'web' ? '10pt' : 10,
            boxShadow: 'rgba(100, 100, 111, 0.2) 0pt 7pt 29pt 0pt',
            marginHorizontal: 0,
            marginVertical: Platform.OS === 'web' ? '30pt' : 30,
            padding: 0
        },
        confirmationCheckbox: {
            color: '#FE0000',
            text: {
                cursor: 'text',
                color: '#707070',
                fontFamily: 'GothamMedium',
                fontSize: Platform.OS === 'web' ? '10pt' : 10,
                marginLeft: 0,
                textAlign: 'left'
            }
        },
        confirmationContainer: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: 25,
            width: '100%'
        },
        confirmationText: {
            color: '#707070',
            fontFamily: 'GothamMedium',
            fontSize: Platform.OS === 'web' ? '12pt' : 12,
            textAlign: 'center',
            width: '100%'
        },
        donationButton: {
            borderRadius: 8,
            borderWidth: 0,
            backgroundColor: '#5C6D7F',
            paddingHorizontal: Platform.OS === 'web' ? '18pt' : 18,
            paddingVertical: Platform.OS === 'web' ? '8pt' : 8
        },
        donationButtonContainer: {
            boxShadow: undefined,
            flexDirection: 'row',
            justifyContent: 'center',
            marginHorizontal: 30,
            marginVertical: 20
        },
        donationButtonDisabled: {
            backgroundColor: '#5C6D7F',
            opacity: 0.4
        },
        donationButtonDisabledTitle: {
            color: '#fff',
            fontWeight: 900,
            fontFamily: 'GothamMedium',
            fontSize: Platform.OS === 'web' ? '30pt' : 30
        },
        donationButtonTitle: {
            color: '#fff',
            fontWeight: 900,
            fontFamily: 'GothamMedium',
            fontSize: Platform.OS === 'web' ? '30pt' : 30
        },
        manualAddressOverrideText: {
            color: 'rgb(255, 165, 0)',
            fontFamily: 'GothamBook',
            fontSize: Platform.OS === 'web' ? '12pt' : 12,
            paddingVertical: 10,
            width: '30%'
        }
    },
    ContributionCard: {
        addDontationButtonContainer: {
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            marginBottom: Platform.OS === 'web' ? '20pt' : 20,
            marginHorizontal: Platform.OS === 'web' ? '20pt' : 20,
            marginTop: Platform.OS === 'web' ? '5pt' : 5,
            paddingRight: 18
        },
        addDontationButtonTitle: {
            color: '#fe0000',
            fontFamily: 'GothamBook',
            fontSize: Platform.OS === 'web' ? '12pt' : 12,
            textDecorationColor: '#fe0000',
            textDecorationLine: 'underline',
            textDecorationStyle: 'solid'
        },
        cardTitle: {
            alignSelf: 'center',
            color: '#707070',
            fontSize: Platform.OS === 'web' ? '30pt' : 30,
            fontFamily: 'GothamMedium',
            fontWeight: 'normal',
            paddingTop: 20,
            textAlign: 'center'
        },
        requireWarning: {
            fontSize: Platform.OS === 'web' ? '10pt' : 10,
            fontFamily: 'GothamBook',
            color: '#FE0000',
            position: 'absolute',
            top: Platform.OS === 'web' ? '2pt' : 5,
            left: Platform.OS === 'web' ? '2pt' : 5
        },
        container: {
            backgroundColor: '#fff',
            borderColor: '#707070',
            borderRadius: 10,
            borderWidth: StyleSheet.hairlineWidth,
            marginHorizontal: 0
        },
        currencySymbol: {
            color: '#A9A9A9',
            fontFamily: 'GothamBook',
            fontSize: Platform.OS === 'web' ? '22pt' : 22,
            paddingRight: Platform.OS === 'web' ? '3pt' : 3
        },
        donationAmountContainer: {
            borderWidth: StyleSheet.hairlineWidth,
            borderColor: '#707070',
            height: 40,
            paddingVertical: 0,
            paddingHorizontal: 0
        },
        input: {
            borderColor: 'transparent',
            borderWidth: 0,
            fontFamily: 'GothamBook',
            fontSize: Platform.OS === 'web' ? '14pt' : 14,
            margin: 0,
            minWidth: '20%',
            padding: 0,
            paddingRight: 5,
            textAlign: 'right'
        },
        inputContainer: {
            alignContent: 'center',
            alignItems: 'center',
            borderColor: 'transparent',
            borderWidth: 0,
            justifyContent: 'flex-end',
            padding: 0,
            textAlignVertical: 'center'
        },
        selectFieldContainer: {
            borderRadius: 4,
            minHeight: 40
        },
        selectField: {
            borderWidth: 0,
            fontFamily: 'sans-serif',
            fontSize: Platform.OS === 'web' ? '12pt' : 12,
            height: '100%',
            paddingLeft: 5
        },
        subtitle: {
            color: '#E7E7E7',
            fontSize: Platform.OS === 'web' ? '42pt' : 42,
            fontFamily: 'GothamBook',
            marginBottom: 10,
            textAlign: 'center'
        }
    },
    Form: {
        asterisk: {
            color: '#FE0000',
            fontWeight: 'bold',
            paddingLeft: Platform.OS === 'web' ? '2pt' : 2
        },
        errorStyle: {
            color: '#FE0000',
            fontFamily: 'GothamBook',
            fontSize: Platform.OS === 'web' ? '10pt' : 10,
            margin: 0,
            paddingLeft: Platform.OS === 'web' ? '3pt' : 3
        },
        inputStyle: {
            fontFamily: 'GothamBook',
            fontSize: Platform.OS === 'web' ? '16pt' : 16,
            width: '100%',
            minHeight: 20,
            paddingBottom: Platform.OS === 'web' ? '2pt' : 2,
            paddingLeft: Platform.OS === 'web' ? '3pt' : 3,
            paddingTop: Platform.OS === 'web' ? '4pt' : 4
        },
        smallInputStyle: {
            fontFamily: 'GothamBook',
            fontSize: Platform.OS === 'web' ? '16pt' : 16,
            width: '100%',
            minHeight: 20,
            paddingBottom: Platform.OS === 'web' ? '2pt' : 2,
            paddingLeft: Platform.OS === 'web' ? '3pt' : 3,
            paddingTop: Platform.OS === 'web' ? '4pt' : 4
        },
        validSmallInputStyle: {
            borderColor: '#008000',
            borderWidth: StyleSheet.hairlineWidth,
            fontFamily: 'GothamBook',
            fontSize: Platform.OS === 'web' ? '12pt' : 12,
            width: '100%',
            paddingBottom: Platform.OS === 'web' ? '2pt' : 2,
            paddingLeft: Platform.OS === 'web' ? '3pt' : 3,
            paddingTop: Platform.OS === 'web' ? '4pt' : 4
        },
        placeholderStyle: {
            fontFamily: 'GothamBook',
            fontSize: Platform.OS === 'web' ? '10pt' : 10,
            margin: 0,
            paddingBottom: Platform.OS === 'web' ? '2pt' : 2,
            paddingLeft: Platform.OS === 'web' ? '3pt' : 3,
            paddingTop: Platform.OS === 'web' ? '4pt' : 4
        },
        label: {
            color: '#333333',
            fontFamily: 'GothamBook',
            fontSize: Platform.OS === 'web' ? '10pt' : 10
        }
    },
    PaymentMethod: {
        container: {
            borderColor: '#707070',
            borderWidth: StyleSheet.hairlineWidth,
            borderRadius: 10,
            alignItems: 'center',
            backgroundColor: '#fff',
            flexDirection: 'row',
            flexWrap: 'wrap',
            marginHorizontal: 0,
            marginVertical: 30,
            padding: 0
        },
        headingText: {
            //fontSize: Platform.OS === 'web' && width > 480 ? '20pt' : 12,
            fontFamily: 'GothamMedium',
            marginLeft: 4,
            textTransform: 'uppercase'
        },
        inputContainer: {
            alignItems: 'center',
            backgroundColor: '#E7E7E7',
            borderBottomEndRadius: 10,
            borderBottomStartRadius: 10,
            padding: Platform.OS === 'web' && width > 480 ? 40 : 20,
            width: '100%'
        },
        inputWrapper: {
            alignItems: 'center',
            backgroundColor: '#fff',
            borderRadius: 6,
            borderColor: '#707070',
            borderWidth: StyleSheet.hairlineWidth,
            justifyContent: 'center',
            paddingBottom: Platform.OS === 'web' ? 60 : 20,
            paddingTop: Platform.OS === 'web' ? 60 : 20,
            width: '100%'
        }
    }
});
